import { BookingPickup } from '@big-red-group/storefront-common-checkout'

export const isPickupRequired = (hasPickups?: string) => hasPickups === 'required'

export const isPickupOptional = (hasPickups?: string) => hasPickups === 'optional'

export const isPickupEnabled = (hasPickups?: string) => hasPickups === 'required' || hasPickups === 'optional'

export const isTrems = (handlerKey?: string) => handlerKey === 'trems2'

export const getMetadataItem = (bookingPickup: BookingPickup, metadataKey: string): string | undefined => {
  if (!bookingPickup) {
    return undefined
  }
  return bookingPickup.metadata.find((meta) => meta.key === metadataKey)?.value
}

// TODO get resellers.isNZAgent() and append it to availabilityId. its harcoded to false for now
export const enhancePickupAvailabilityId = (
  handlerKey: string | undefined,
  availablityId: string | undefined
): string | undefined => {
  return handlerKey === 'fareharbor' ? availablityId?.concat('-false') : availablityId
}
